import React from 'react';
// Import the icons you need
import { FaPaintRoller, FaLightbulb, FaLayerGroup, FaHome, FaBuilding, FaHammer } from 'react-icons/fa';
import { GiWoodenChair, GiTable, GiModernCity } from 'react-icons/gi';
import { MdOutlineKitchen, MdOutlineVilla } from 'react-icons/md';

export const servicesData = [
  {
    id: 1,
    title: "Modular Kitchens",
    description: "Experience culinary excellence with our bespoke modular kitchens, where innovative design meets exceptional functionality.",
    category: "remodeling",
    path: "/services/modular-kitchens",
    startingPrice: "₹1,99,999",
    duration: "4-6 Weeks",
    rating: "4.9",
    features: [
      "Custom-designed cabinetry",
      "Ergonomic workflow optimization",
      "Integrated smart appliances",
      "Durable, easy-to-clean surfaces",
      "Vastu-aligned kitchen layout tips (light-touch)"
    ],
    imageUrl: "https://rdsoftware.in/wp-content/uploads/2025/08/service-1.jpg",
    icon: <MdOutlineKitchen />,
    iconColor: '#e74c3c'
  },
  {
    id: 2,
    title: "Wardrobe Design",
    description: "Smart storage solutions that maximize space while perfectly complementing your interior style.",
    category: "furniture",
    path: "/services/wardrobes",
    startingPrice: "₹2,49,999",
    duration: "2-3 Weeks",
    rating: "4.8",
    features: [
      "Custom walk-in & reach-in closets",
      "Sliding and hinged door designs",
      "Premium mirror & glass finishes",
      "Smart internal organization systems",
      "Zodiac-inspired finishes and ideal wardrobe"
    ],
    imageUrl: "https://rdsoftware.in/wp-content/uploads/2025/08/service-2.jpg",
    icon: <GiWoodenChair />, // Note: A bed or closet icon might be more fitting
    iconColor: '#3498db'
  },
  {
    id: 3,
    title: "Lighting Solutions",
    description: "Transformative lighting schemes that create the perfect ambiance and enhance your home's architecture.",
    category: "decor",
    path: "/services/lighting",
    startingPrice: "₹49,999",
    duration: "1-2 Weeks",
    rating: "4.9",
    features: [
      "Layered ambient & task lighting",
      "Energy-efficient LED solutions",
      "Smart, automated lighting controls",
      "Statement chandeliers & fixtures",
      "Circadian and Vastu-friendly illumination guidance"
    ],
    imageUrl: "https://rdsoftware.in/wp-content/uploads/2025/08/service-3.jpg",
    icon: <FaLightbulb />,
    iconColor: '#f1c40f'
  },
  {
    id: 4,
    title: "Flooring & Tiling",
    description: "A foundation of elegance with premium flooring options that combine durability with timeless style.",
    category: "remodeling",
    path: "/services/flooring",
    startingPrice: "₹1,25,999",
    duration: "1-3 Weeks",
    rating: "4.7",
    features: [
      "Hardwood & engineered wood floors",
      "Luxury vinyl & laminate",
      "Porcelain & ceramic tiles",
      "Natural stone options",
      "Element-balanced material suggestions (light-touch)"
    ],
    imageUrl: "https://rdsoftware.in/wp-content/uploads/2025/08/service-4.jpg",
    icon: <GiTable />, // Note: A floor tile or layer icon might be more fitting
    iconColor: '#8e44ad'
  },
  {
    id: 5,
    title: "False Ceilings",
    description: "Innovative and aesthetic ceiling designs that redefine your space and conceal wiring.",
    category: "finishes",
    path: "/services/false-ceilings",
    startingPrice: "₹89,999",
    duration: "1-2 Weeks",
    rating: "4.8",
    features: [
      "Modern Gypsum & POP designs",
      "Integrated acoustic solutions",
      "Concealed LED cove lighting",
      "Custom geometric patterns",
      "Auspicious zone considerations for ceiling layouts"
    ],
    imageUrl: "https://rdsoftware.in/wp-content/uploads/2025/08/service-5.jpg",
    icon: <FaLayerGroup />,
    iconColor: '#2ecc71'
  },
  {
    id: 6,
    title: "Wall Finishes",
    description: "Creative wall treatments that serve as the perfect backdrop, transforming your space with color and texture.",
    category: "finishes",
    path: "/services/wall-design",
    startingPrice: "₹74,999",
    duration: "1-2 Weeks",
    rating: "4.9",
    features: [
      "Premium paints & eco-friendly options",
      "Stylish wall paneling & cladding",
      "Textured & decorative finishes",
      "Designer wallpapers & murals",
      "Palette suggestions aligned with your element/zodiac"
    ],
    imageUrl: "https://rdsoftware.in/wp-content/uploads/2025/08/service-6.jpg",
    icon: <FaPaintRoller />,
    iconColor: '#e67e22'
  },
  {
    id: 7,
    title: "Complete Home Interiors",
    description: "End-to-end interior design solutions that transform your house into a dream home with a cohesive design language.",
    category: "full-service",
    path: "/services/complete-home-interiors",
    startingPrice: "₹12,99,999",
    duration: "8-12 Weeks",
    rating: "5.0",
    features: [
      "Space planning & layout design",
      "Complete material selection",
      "Custom furniture & built-ins",
      "Lighting & decor planning",
      "Light-touch Vastu & zodiac-led planning available"
    ],
    imageUrl: "https://rdsoftware.in/wp-content/uploads/2025/08/service-7.jpg",
    icon: <FaHome />,
    iconColor: '#9b59b6'
  },
  {
    id: 8,
    title: "Luxury Interiors",
    description: "Opulent and exclusive interior designs that reflect your sophisticated taste and lifestyle.",
    category: "luxury",
    path: "/services/luxury-interiors",
    startingPrice: "₹24,99,999",
    duration: "12-16 Weeks",
    rating: "5.0",
    features: [
      "Premium material selection",
      "Custom luxury furniture",
      "Smart home integration",
      "Bespoke lighting solutions",
      "Personalized astro-led accents (subtle)"
    ],
    imageUrl: "https://rdsoftware.in/wp-content/uploads/2025/08/service-8.jpg",
    icon: <MdOutlineVilla />,
    iconColor: '#e67e22'
  },
  {
    id: 9,
    title: "Construction & Renovation",
    description: "Complete construction and renovation services to bring your architectural vision to life with precision and quality.",
    category: "construction",
    path: "/services/construction-renovation",
    startingPrice: "₹3,49,999",
    duration: "Varies by project",
    rating: "4.8",
    features: [
      "Structural modifications",
      "Complete home renovations",
      "Quality material sourcing",
      "Project management",
      "Vastu-informed orientation guidance (on request)"
    ],
    imageUrl: "https://rdsoftware.in/wp-content/uploads/2025/08/service-9-1.jpg",
    icon: <FaHammer />,
    iconColor: '#3498db'
  }
];